var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef3d32",
    stroke: "#8b0000",
    strokeWidth: 2,
    d: "M95.983 32H0v4a8 8 0 0 0 8 8h12a8 8 0 0 0 8-8 8 8 0 0 0 8 8h24a8 8 0 0 0 8-8 8 8 0 0 0 8 8h12a8 8 0 0 0 8-8v-4zM95.017 28 87.846 2.9A4 4 0 0 0 84 0H65.679l5.6 28zM30.321 0H12a4 4 0 0 0-3.846 2.9L.983 28h23.738zM57.521 0H38.479l-5.6 28h30.242zM76 48a11.953 11.953 0 0 1-8-3.063A11.953 11.953 0 0 1 60 48H36a11.953 11.953 0 0 1-8-3.063A11.953 11.953 0 0 1 20 48H8a11.922 11.922 0 0 1-4-.7V92a4 4 0 0 0 4 4h8V60a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v36h44a4 4 0 0 0 4-4V47.3a11.922 11.922 0 0 1-4 .7zm4 24a4 4 0 0 1-4 4H56a4 4 0 0 1-4-4V60a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStore);
export default __webpack_public_path__ + "static/media/ic_store.2bf7e6127270355c6b1a75814b0af546.svg";
export { ForwardRef as ReactComponent };